import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import DropdownMechanism from '../../../../../GeneralComponents/DropdownMechanism';

// Row to add parameters on the query
function MethodFilterSelection(props) {
  const {
    selectedProject,
    entity,
    attributeParam,
    setAttributeParam,
    valueParam,
    setValueParam,
    index,
    logicalOperatorParam,
    setLogicalOperatorParam,
    comparisonOperatorParam,
    setComparisonOperatorParam,
  } = props;

  // States
  const [selectedAttribute, setSelectedAttribute] = useState(attributeParam);
  const [selectedValue, setSelectedValue] = useState(valueParam[index]);
  const [selectedLogicalOperator, setSelectedLogicalOperator] = useState(
    logicalOperatorParam[index] !== undefined ? logicalOperatorParam[index] : 'none'
  );
  const [selectedComparisonOperator, setSelectedComparisonOperator] = useState(
    comparisonOperatorParam[index] !== undefined ? comparisonOperatorParam[index] : 'none'
  );
  
  // Functions to delete a param or add a new one
  const deleteParam = () => {
    setAttributeParam((prevAttributes) => {
      const updatedAttributes = [...prevAttributes];
      updatedAttributes.splice(index, 1);
      return updatedAttributes;
    });

    setValueParam((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues.splice(index, 1);
      return updatedValues;
    }
    );

    setLogicalOperatorParam((prevLogicalOperators) => {
      const updatedLogicalOperators = [...prevLogicalOperators];
      updatedLogicalOperators.splice(index, 1);
      return updatedLogicalOperators;
    } 
    );

    setComparisonOperatorParam((prevComparisonOperators) => {
      const updatedComparisonOperators = [...prevComparisonOperators];
      updatedComparisonOperators.splice(index, 1);
      return updatedComparisonOperators;
    }
    );
}

  const addAttribute = () => {
    // Set a limit of 4 parameters per query
    // Then add a new row
    if(logicalOperatorParam.length > 4){
      return
    }
    setAttributeParam((prevAttributes) => [...prevAttributes, 'none']);
    setValueParam((prevValues) => [...prevValues, '']);
    setLogicalOperatorParam((prevLogicalOperators) => [...prevLogicalOperators, 'none']);
    setComparisonOperatorParam((prevComparisonOperators) => [...prevComparisonOperators, 'none']);
  };

  // Functions to update the states
  useEffect(() => {
    if (selectedAttribute !== attributeParam) {
      setAttributeParam((prevAttributes) => {
        const updatedAttributes = [...prevAttributes];
        updatedAttributes[index] = selectedAttribute;
        return updatedAttributes;
      });
    }
  }, [selectedAttribute]);

  useEffect(() => {
    setValueParam((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[index] = selectedValue;
      return updatedValues;
    });
  }, [selectedValue]);

  useEffect(() => {
    setLogicalOperatorParam((prevLogicalOperators) => {
      const updatedLogicalOperators = [...prevLogicalOperators];
      updatedLogicalOperators[index] = selectedLogicalOperator;
      return updatedLogicalOperators;
    });
  }, [selectedLogicalOperator]);

  useEffect(() => {
    setComparisonOperatorParam((prevComparisonOperators) => {
      const updatedComparisonOperators = [...prevComparisonOperators];
      updatedComparisonOperators[index] = selectedComparisonOperator;
      return updatedComparisonOperators;
    });
  }, [selectedComparisonOperator]);

  if (entity === 'none') return null;

  const tempDataCombinations = JSON.parse(localStorage.getItem('data'))[selectedProject]
    .annotations[0].combinations;

  const filteredData = tempDataCombinations.filter(
    (item) => item.annotationType === 'attribute' && item.annotationLink === entity
  );
  const filteredAttributes = filteredData.map((item) => item.annotationName);
  // Find the attributes of the selected entity

  const logicalOperators = ['AND', 'OR'];

  const comparisonOperators = [ 'Equal To', 'Not Equal To', 'Greater Than', 'Less Than', 'Greater Than Or Equal To', 'Less Than Or Equal To' ];

  return (
    <div className={clsx('spacingTopDiv')} style={{ display: 'flex', flexDirection: 'column' }}>
      {index === 0 && <span>Add parameters :</span>}
      <div className={clsx('spacingTopDiv')} style={{ display: 'flex', flexDirection: 'row' }}>
        
        <span style={{ display: 'inline-block', marginLeft: '6.7vw' }} />
        <div className={clsx('flexProps2')}>
          <div>
            <span>
              <DropdownMechanism
                target={attributeParam}
                targets={filteredAttributes}
                selectTarget={setSelectedAttribute}
              />
            </span>
            <span style={{ margin: '5px' }}>
              <DropdownMechanism
                target={comparisonOperatorParam[index]}
                targets={comparisonOperators}
                selectTarget={setSelectedComparisonOperator}
              />
            </span>
            <span>
              <input
                className={clsx('inputFilter')}
                type="text"
                value={valueParam[index]}
                onChange={(e) => {
                  if (e.target.value.includes(`'`) || e.target.value.includes(`"`)) {
                    console.log('Invalid character');
                    return;
                  }
                  setSelectedValue(e.target.value);
                }}
                placeholder="Enter value"
              />
            </span>

            <button
              onClick={addAttribute}
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                paddingLeft: '5px',
                cursor: 'pointer',
              }}
            >
              +
            </button>
            { logicalOperatorParam[index+1] !== undefined &&
              <span style={{ margin: '5px' }}>
                <DropdownMechanism
                  target={logicalOperatorParam[index]}
                  targets={logicalOperators}
                  selectTarget={setSelectedLogicalOperator}
                />
              </span>
            }
            { index !== 0 && 
              <button onClick={deleteParam}
              className={clsx('fas', 'fa-times-circle', 'teamSelector')}
              style={{ border: 'none', marginLeft: '5px'}}/>
            }
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default MethodFilterSelection;
